import {
  SURVEY_MIGRATION_SETTINGS_INIT,
  SURVEY_MIGRATION_SETTINGS_REVIEW_DATA_CUTS,
  GET_SELECTED_SURVEYS_START,
  GET_SELECTED_SURVEYS_SUCCESS,
  SET_MIGRATION_DATA,
  TOGGLE_DATA_CUT_SHOW,
  SET_DATA_CUT_OPTION,
  SET_TYPE_OF_REVIEW,
  SET_AUTO_REVIEW_OPTION,
  MIGRATION_SLIDE_OUT_CLOSE
} from '../actions/MigrationSettingsActions';

import {
  SET_PRIORITY_BASED_DATA_CUTS_START,
  SET_PRIORITY_BASED_DATA_CUTS_SUCCESS
} from '../actions/MigrationProcessActions';

export const initialState = {
  reviewingDataCuts: false,
  selectedSurveys: [],
  dataCutOptionsSaved: false,
  noExceptions: false,
  curSurveyYear: null,
  newSurveyYear: null,
  showDataCut: false,
  dataCutOption: 'exceptions',
  typeOfReview: 'auto',
  autoReviewOption: 'current',
  shouldShowSlideout: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MIGRATION_SLIDE_OUT_CLOSE:
      return {
        ...initialState
      };
    case SURVEY_MIGRATION_SETTINGS_INIT:
      return {
        ...state
      };
    case SURVEY_MIGRATION_SETTINGS_REVIEW_DATA_CUTS:
      return {
        ...state,
        reviewingDataCuts: action.payload
      };
    case GET_SELECTED_SURVEYS_START:
      return {
        ...state
      };
    case GET_SELECTED_SURVEYS_SUCCESS:
      const dataCutOptionsSaved = action.payload.find(survey => survey.hasDataCutOptions) ? true : false;
      const noExceptions = action.payload.find(survey => survey.totalExceptions > 0) ? false : true;
      return {
        ...state,
        selectedSurveys: action.payload || [],
        dataCutOptionsSaved,
        noExceptions,
        shouldShowSlideout: (action.payload && action.payload.length !== 0) || false
      };
    case SET_MIGRATION_DATA:
      return {
        ...state,
        shouldShowSlideout: false,
        curSurveyYear: action.payload.curSurveyYear,
        newSurveyYear: action.payload.newSurveyYear,
        gridStore: action.payload.gridStore
      };
    case TOGGLE_DATA_CUT_SHOW:
      return {
        ...state,
        showDataCut: !state.showDataCut
      };
    case SET_DATA_CUT_OPTION:
      return {
        ...state,
        dataCutOption: action.payload
      };
    case SET_TYPE_OF_REVIEW:
      return {
        ...state,
        typeOfReview: action.payload
      };
    case SET_AUTO_REVIEW_OPTION:
      return {
        ...state,
        autoReviewOption: action.payload
      };
    case SET_PRIORITY_BASED_DATA_CUTS_START:
      return {
        ...state
      };
    case SET_PRIORITY_BASED_DATA_CUTS_SUCCESS:
      return {
        ...state
      };
    default:
      return state;
  }
}
